import React from "react";
import { socials, badges } from "../../v3/data";

const Hero = () => (
  <header
    id="top"
    style={{
      padding: "100px 0 96px",
      position: "relative",
      overflow: "hidden",
      background:
        "radial-gradient(640px 520px at 82% 38%, color-mix(in oklab, var(--accent) 12%, transparent), transparent 70%), linear-gradient(160deg, #ffffff 50%, var(--accent-soft) 100%)",
    }}
  >
    <div className="pagewrap hero-grid posrel">
      <div>
        <div className="chip-term fadeup mb24">
          <span className="dot-live" />
          status: <span id="typed">available_for_projects</span>
          <span className="caret" />
        </div>
        <h1
          className="fadeup"
          style={{
            fontSize: "clamp(42px, 4.8vw, 66px)",
            lineHeight: 1.04,
            letterSpacing: "-.03em",
            fontWeight: 700,
            margin: "0 0 24px",
            animationDelay: ".08s",
          }}
        >
          I build AI-powered, full-stack products that{" "}
          <span
            style={{
              color: "var(--accent)",
              textDecoration: "underline",
              textDecorationThickness: 4,
              textUnderlineOffset: 8,
              textDecorationColor: "var(--accent-line)",
            }}
          >
            ship to production
          </span>
          .
        </h1>
        <p className="lead fadeup" style={{ fontSize: 18, maxWidth: 520, margin: "0 0 36px", animationDelay: ".16s" }}>
          Software Engineer with 5+ years across web apps, LLM chatbots, and AWS serverless. Top Rated Plus on Upwork.
        </p>
        <div className="fx gap12 wrap ac fadeup" style={{ animationDelay: ".24s" }}>
          <a href="#contact" className="btn btn-primary">
            Book a call<span className="arr">→</span>
          </a>
          <a href="#work" className="btn btn-ghost">
            View work
          </a>
          <span className="hide-mobile" style={{ width: 1, height: 28, background: "var(--line)", margin: "0 8px" }} />
          <div className="fx ac gap10">
            {socials.map((s) => (
              <a key={s.label} href={s.href} className="socbtn" title={s.label} target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d={s.icon} />
                </svg>
              </a>
            ))}
          </div>
        </div>
        <div className="fx wrap ac fadeup" style={{ gap: "14px 28px", marginTop: 40, animationDelay: ".32s" }}>
          {badges.map((b) => (
            <span key={b} className="check">
              {b}
            </span>
          ))}
        </div>
      </div>

      <div className="posrel fadeup" style={{ justifySelf: "end", width: "100%", maxWidth: 410, animationDelay: ".2s" }}>
        {/* square stage so the accent circle and the image mask share the exact
            same geometry — the image bottom clips flush with the circle edge */}
        <div className="posrel" style={{ width: "100%", aspectRatio: "1/1" }}>
          <svg viewBox="0 0 200 200" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0, overflow: "visible" }} aria-hidden="true">
            <circle cx="100" cy="106" r="66" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeDasharray="360 55" transform="rotate(-35 100 106)" />
            <circle cx="100" cy="106" r="70" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeDasharray="355 85" transform="rotate(150 100 106)" />
          </svg>
          <div
            style={{ position: "absolute", width: "60%", height: "60%", borderRadius: "50%", background: "var(--accent)", top: "23%", left: "20%", zIndex: 1 }}
          />
          <div className="hero-cutout-mask" style={{ position: "absolute", inset: 0, zIndex: 2 }}>
            <div style={{ position: "absolute", left: "10.5%", bottom: "17%", width: "79%", aspectRatio: "954/993" }}>
              <img src="/assets/mohsin-cutout.png" alt="Mohsin Idrees" style={{ display: "block", width: "100%", height: "100%" }} />
            </div>
          </div>
        </div>
        <div className="floatchip" style={{ top: "6%", right: "-14%", zIndex: 3 }}>{"</> ai_integrated_saas_products"}</div>
        <div className="floatchip" style={{ top: "56%", right: "-20%", animationDelay: "-1.8s", zIndex: 3 }}>λ agentic_ai_solutions</div>
        <div className="floatchip" style={{ bottom: "2%", left: "-16%", animationDelay: "-3.4s", zIndex: 3 }}>◆ system_design</div>
        <div className="mono fx jb ac posrel" style={{ fontSize: 11, color: "var(--muted)", marginTop: 20, letterSpacing: ".08em", zIndex: 3 }}>
          <span>FIG. 01 — MOHSIN IDREES</span>
          <span>REMOTE · WORLDWIDE</span>
        </div>
        <div
          className="card fx ac gap10"
          style={{ position: "absolute", bottom: "14%", left: "-13%", padding: "12px 16px", borderRadius: 10, boxShadow: "0 16px 32px -16px rgba(15,23,42,.25)", zIndex: 3 }}
        >
          <span className="mono" style={{ fontSize: 18, color: "var(--accent)", fontWeight: 600 }}>
            100%
          </span>
          <div className="mono" style={{ fontSize: 10, color: "var(--muted)", lineHeight: 1.5 }}>
            JOB SUCCESS
            <br />
            TOP RATED PLUS
          </div>
        </div>
      </div>
    </div>

    <div
      className="hide-mobile"
      style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", bottom: 20, display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}
    >
      <div className="mouse">
        <span />
      </div>
      <span className="mono" style={{ fontSize: 10, letterSpacing: ".18em", color: "#94A3B8" }}>
        SCROLL
      </span>
    </div>
  </header>
);

export default Hero;
